/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    baseInfo: {},
    apiConfig: {},
    testRet: {}
};
const handler = {
    _getUrl(rootState) {
        let url = rootState.$config.api.app.baseinfo;
        return _.replace(url, '{game_code}', rootState.$helper.helper.getGameCode().game_code);
    }
}
/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {

    SET_API_CONFIG({state, commit, dispatch, rootState}, args) {
        commit('_setApiConfig', args);
    },
    UPDATE_API_CONFIG({state, commit, dispatch, rootState}, args) {
        let url = handler._getUrl(rootState)
        commit('PRIVATE_LOADING', true, {root: true});
        rootState.$helper.request.put(url, args).then(function (data) {
            dispatch('GET_ACTIVE_GAME_INFO',null, {root: true});
            commit('PRIVATE_LOADING', false, {root: true});
            dispatch('ALERT_HANDLE', {message: '提交成功！', reload: true}, {root: true});
        }).catch((res) => {
            dispatch('ERROR_HANDLE', res, {root: true});
            commit('PRIVATE_LOADING', false, {root: true});
        });
    },
    REMOVE_API_CONFIG({state, commit, dispatch, rootState}, args) {
        commit('_removeApiConfig', args);
    },
    CURL_TEST_URL({state, commit, dispatch, rootState}, args) {
        let appUrl = rootState.$config.api.app;
        let url = appUrl['test_' + args.type];
        args.game_code = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get(url, args).then(function (data) {
            commit('PRIVATE_LOADING', false, {root: true});
            commit('_curlTestUrl', eval('(' + data.data.response + ')'));

        }).catch((res) => {
            dispatch('ERROR_HANDLE', res, {root: true});
            commit('PRIVATE_LOADING', false, {root: true});
        });
    },
    RESET_TEST_RET({state, commit, dispatch, rootState}, args) {
        commit('_resetTestRet', '');
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _setApiConfig(state, args) {
        let isExist = false;
        _.forEach(state.apiConfig, function (item, ind) {
            if (args.key === item.key) {
                isExist = true;
                state.apiConfig[ind] = args;
            }
        });
        if (!isExist) {
            state.apiConfig[args.key] = args;
        }
    },

    /****
     * @param state
     * @param args
     * @private
     */
    _removeApiConfig(state, args) {
        let temp = [];
        for(let key in state.apiConfig) {
            temp.push(state.apiConfig[key]);
        }
        temp = temp.filter(tab => tab.key !== args);
        let res = {};
        let len = temp.length;
        for(let i = 0 ; i < len; i++) {
            res[temp[i]['key']] = temp[i];
        }
        state.apiConfig = Object.assign({}, res);
    },
    _curlTestUrl(state, args) {
        state.testRet = args;
    },
    _resetTestRet(state, args) {
        state.testRet = '';
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/gameConfig/commonInfo.js